export default {"src":"/bnb/_next/static/media/wombat.8dbd3057.svg","height":24,"width":24};